import { useContext } from 'react';
import { Box, TableCell, TableRow } from '@mui/material';
import { hasCreditModel, hasDepositModel, hasPINModel } from 'helpers/businesses';
// Our Components
import { AuthContext } from 'context/auth-context';
// Utils and Helpers
import { formatDate } from 'helpers/formatDate';
import { numberFormat } from 'helpers/i18n';
import { TRANSFER_TYPE, TRANSFER_TYPE_MAP } from 'helpers/constants';
// Assets
import { ReactComponent as PaystandLogo } from 'assets/overviewSection/LogoWithoutText.svg';
import './FundingHistoryTableRow.css';

const getBankAccountInfo = (transaction, businessInfo) => {
    if (hasPINModel(businessInfo)) {
        return (
            <Box className="funding-history-table-row-cell" display="flex" alignItems="center">
                <PaystandLogo style={{ marginRight: '8px' }} />
                Paystand AR Account
            </Box>
        );
    }
    if (hasDepositModel(businessInfo) && transaction.transfer_type === TRANSFER_TYPE.INTRABANK) {
        return <Box className="funding-history-table-row-cell">Paystand Corporate</Box>;
    }
    if (hasCreditModel(businessInfo) && transaction.transfer_type === TRANSFER_TYPE.INTRABANK) {
        return <Box className="funding-history-table-row-cell">Paystand Corporate</Box>;
    }
    return (
        <>
            <Box className="funding-history-table-row-cell">{transaction.bank_name}</Box>
            <Box className="funding-history-table-row-cell">{transaction.account_number}</Box>
        </>
    );
};
function FundingHistoryTableRow({ transaction, statusFormatter, setIsAchDetailsOpen, setSelectedAchTransaction }) {
    const { businessInfo } = useContext(AuthContext);

    return (
        <TableRow
            key={transaction.id}
            hover
            role="checkbox"
            onClick={() => {
                setSelectedAchTransaction(transaction);
                setIsAchDetailsOpen(true);
            }}>
            <TableCell className="funding-history-table-row-cell" align="left">
                <Box className="fw-bold">{transaction.id}</Box>
            </TableCell>
            <TableCell className="funding-history-table-row-cell" align="left">
                {formatDate(transaction.transaction_date)}
            </TableCell>
            <TableCell>{getBankAccountInfo(transaction, businessInfo)}</TableCell>
            <TableCell className="funding-history-table-row-cell">
                {TRANSFER_TYPE_MAP[`${transaction.transfer_type}-${transaction.transaction_type}`] || 'Other'}
            </TableCell>
            <TableCell>{statusFormatter(transaction)}</TableCell>
            <TableCell className="funding-history-table-row-cell">
                <Box className="fw-bold">{numberFormat(Number(transaction.amount) / 100, 2, 2)}</Box>
            </TableCell>
        </TableRow>
    );
}

export default FundingHistoryTableRow;
